import { render, staticRenderFns } from "./exercises-wrong-title.vue?vue&type=template&id=32dda2d4"
import script from "./exercises-wrong-title.vue?vue&type=script&lang=js"
export * from "./exercises-wrong-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports